var React = require('react');

function LinkedInLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","className":"icon-fill","fillRule":"evenodd","d":"M25.987 25.32h-4.305v-7.586c0-1.764-.623-2.967-2.181-2.967-1.19 0-1.898.811-2.21 1.595-.113.28-.141.672-.141 1.064v7.894h-4.305v-9.322c0-1.707-.057-3.135-.113-4.367h3.738l.199 1.904h.084c.567-.896 1.955-2.212 4.277-2.212 2.833 0 4.957 1.876 4.957 5.907v8.09zM8.087 9.952C6.727 9.952 5.85 9 5.85 7.824c0-1.203.906-2.127 2.294-2.127 1.387 0 2.237.924 2.266 2.127 0 1.176-.879 2.128-2.323 2.128zM5.963 25.32h4.305V11.63H5.963V25.32zM28.773 0H3.227C1.444 0 0 1.432 0 3.2V28.8C0 30.568 1.444 32 3.226 32h25.548C30.556 32 32 30.568 32 28.801V3.2C32 1.432 30.556 0 28.774 0z"}));
}

LinkedInLogo.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = LinkedInLogo;

LinkedInLogo.default = LinkedInLogo;
